export const LOGIN_USER_INFO = 'LOGIN_USER_INFO';

export function loginUserInfo(loginuser) {
  return {
    type: LOGIN_USER_INFO,
    loginuser,
  };
}

